import React, { Component } from "react";
import axios from "axios";
import { BASE_URL, SIZES, HEADERS } from "../../common/api";
import { Form, Modal, Button } from "react-bootstrap";
import Pagination from "../../common/pagination";


export class Size extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      sizes: [],
      id:'',
      vSizeId: "",
      type: "",
      priority: "",
      status: 0,
      filters: {
        width: "",
        length: "",
      },
      width:"", 
      length:"",
      currentPage: 1,
      totalPages: 1
    };
    this._isMounted = false;
  }

  handleFilter = (event, stateVariable) => {
    this.setState({
      filters: {
        ...this.state.filters,
        [stateVariable]: event.target.value,
      },
    });
  };

  handleCancel = (stateVariable) => {
    this.setState({
      filters: {
        ...this.state.filters,
        [stateVariable]: "",
      },
    });
  };

  handlePageChange(pageNumber) {
    this.setState({
      currentPage: pageNumber
    });
    this.getData(pageNumber)
  }

  addOrUpdate = (event) => {
    // event.preventDefault();
    const { priority,  id } = this.state;
    const data ={
      priority: priority
    }
    console.log("update")
    if (id) {
      axios.patch(BASE_URL + SIZES + id + "/", data, HEADERS).then((res) => {
        const { sizes } = this.state;
        const index = sizes.findIndex((style) => style.id === id);
        sizes[index] = res.data;
        this.setState({ sizes: sizes, show: false });
      }).catch((err) => {
        console.log(err);
      })
    }
  };

  getTitle = () => {
    const { id } = this.state;
    if (id) {
      return <h3>Изменить</h3>;
    } else {
      return <h3>Добавить новый</h3>;
    }
  };

  // get = (data) => {
  //   this.setState({
  //     nameUz: data.nameUz,
  //     nameRu: data.nameRu,
  //     priority: data.priority,
  //     image: data.image,
  //     id: data.id,
  //     show: true,
  //   });
  // };

  getData = (pageNumber=1) => {
    this._isMounted = true;
    axios
      .get(BASE_URL + SIZES + `?page=${pageNumber}`, { params: this.state.filters },HEADERS)
      .then((res) => {
        if (this._isMounted) {
          this.setState({ sizes: res.data.results, totalPages: Math.ceil(res.data.count / 21) });
        }
      })
      .catch((err) => {
        this.setState({ status: err.response.status });
      });
  }

  componentDidMount() {
    this.getData();
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };
  showModal = (id) => {
    const data = this.state.sizes.find((size) => size.id === id);
    console.log(data);
    this.setState({ show: true, id: data.id, priority: data.priority, width: data.width, length: data.length, vSizeId: data.vSizeId, type: data.shape, id: id, });
  };
  hideModal = async () => {
    await  this.addOrUpdate();
    this.setState({ show: false, confirm: false });
  };
  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.filters !== this.state.filters) {
      this.getData();
    }
  }

  render() {
    const {currentPage, totalPages, show, id, priority, vSizeId, length, width, type } = this.state;
    return (
      <div>
        <Modal
          show={show}
          onHide={() => {
            this.hideModal();
          }}
          animation={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>{this.getTitle()}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
          <Form onSubmit={(event) => this.addOrUpdate(event)}>
          <h6>Код: {vSizeId} </h6>
          <h6> Ширина: {width} см</h6>
          <h6>Длина: {length} см</h6>
          <h6>Тип: {type} </h6>
            
              <Form.Group className="mb-3" key={id}>
                <Form.Label>Приоритет:</Form.Label>
                <Form.Control
                  type="number"
                  name="priority"
                  value={priority}
                  onChange={this.handleChange}
                />
              </Form.Group>
              <Button variant="primary" type="submit" onClick={this.hideModal}>
                Сохранить
              </Button>
            </Form>
          </Modal.Body>
        </Modal>
        <div className="filters row">
          <div className="col-6">
            <Form.Label>Ширина:</Form.Label>
            <Form.Control
              type="number"
              name="width"
              onChange={(event) => this.handleFilter(event, "width")}
            />
          </div>
          <div className="col-6">
            <Form.Label>Длина:</Form.Label>
            <Form.Control
              type="number"
              name="length"
              onChange={(event) => this.handleFilter(event, "length")}
            />
          </div>
        </div>
        <table className="table table-hover mx-2">
          <thead className="thead-light">
            <tr>
              <th>Код</th>
              <th>Ширина</th>
              <th>Длина</th>
              <th>Площадь</th>
              <th>Тип</th>
              <th>Приоритет</th>
            </tr>
          </thead>
          <tbody>
            {this.state.sizes.map((size) => (
              <tr key={size.id} onClick={() => this.showModal(size.id)}  style={{cursor: 'pointer'}}>
                <td>{size.vSizeId}</td>
                <td>{size.width}</td>
                <td>{size.length}</td>
                <td>{size.width * size.length}</td>
                <td>{size.shape}</td>
                <td>{size.priority !== 0 ? size.priority : ""}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={(num)=>this.handlePageChange(num)}
        />
      </div>
    );
  }
}

export default Size;

